
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Navigation } from 'swiper'
SwiperCore.use([Navigation])
export default {
  name: 'Development',
  data() {
    return {
      index: 0,
      isSlide: false,
      development: [
        {
          year: 2025,
          content: [
            {
              month: '1月',
              event: ['获得业务连续性管理体系认证']
            },
            {
              month: '4月',
              event: ['喜迎泰国客商莅临洽谈，深化跨国友谊，夯实国际业务根基']
            },
            {
              month: '6月',
              event: ['荣获美团金融颁发的“年度核心供应商”奖项']
            },
            {
              month: '8月',
              event: ['荣获携程金融颁发的“年度优质服务奖”奖项']
            },
            {
              month: '12月',
              event: ['以《我们Always Day One》为主题的十一周年司庆隆重举办，回望深耕之路，共启稳健前行新征程']
            }
          ]
        },
        {
          year: 2024,
          content: [
            {
              month: '1月',
              event: ['总部迁至北京CBD核心区域，正式开启十年奋进新篇章']
            },
            {
              month: '2月',
              event: ['荣获携程金融颁发的“最佳合作机构”称号']
            },
            {
              month: '3月',
              event: ['荣获京东科技颁发的“委外核心机构”及“砥砺奋进奖”奖项']
            },
            {
              month: '5月',
              event: ['再次获得12项计算机软件著作权认证']
            },
            {
              month: '8月',
              event: ['荣获美团金融授予的“委外合作厂商核心贡献奖”奖项']
            },
            {
              month: '12月',
              event: ['以《追光“十”刻，同心通行”》为主题的十周年集团庆典盛大启幕，共同回顾十年发展历程，展望未来发展前景']
            }
          ]
        },
        {
          year: 2023,
          content: [
            {
              month: '1月',
              event: ['国家发明专利语义识别方法、装置、存储介质及处理器”获得国家知识产权局正式授权。”']
            },
            {
              month: '3月',
              event: ['获评“北京市专精特新”中小企业']
            },
            {
              month: '6月',
              event: ['首批入驻泉州海丝金融法务区信用修复中心']
            },
            {
              month: '7月',
              event: ['获评华夏银行“早期委外重要机构”荣誉称号']
            },
            {
              month: '11月',
              event: ['成为乐平基金会残障融合实验室企业行动联盟成员']
            }
          ]
        },
        {
          year: 2022,
          content: [
            {
              month: '4月',
              event: ['互连众信入选首批朝阳区未来独角兽企业榜单，将作为全区创新发展新典型，纳入“朝阳区独角兽培育企业库”。']
            }, {
              month: '5月',
              event: ['我司成功中标中国工商银行信用卡处置智能助手采购项目。此次项目中标，是公司在“AI智能引擎产品”技术领域、业务拓展方面又一个新的里程碑。']
            }, {
              month: '6月',
              event: ['互连众信获得6项计算机软件著作权认证。']
            }
          ]
        }, {
          year: 2021,
          content: [
            {
              month: '3月',
              event: ['我司合肥研发中心正式投入运营，主要承担AI算法研究与开发工作，为公司产品研发及业务发展提供智能化支撑。']
            }, {
              month: '5月',
              event: ['经上级党委批准，北京互连众信科技有限公司支部委员会正式成立。']
            }, {
              month: '7月',
              event: ['企业经营与发展能力获北京市朝阳区管委会认可，新场景示范应用项目获得“高新技术产业发展引导资金”支持。']
            }, {
              month: '10月',
              event: ['「灵工星球」与泰国自由职业雇佣平台Fastwork共同宣布达成战略合作。']
            }
          ]
        }, {
          year: 2020,
          content: [
            {
              month: '3月',
              event: ['印尼Fintech协会会员。', '获得泰国不良资产管理公司牌照。']
            }, {
              month: '12月',
              event: ['简周集团正式成立，运用数字科技手段推动产业效能升级。']
            }
          ]
        }, {
          year: 2019,
          content: [
            {
              month: '7月',
              event: ['正式加入北京信用协会，成为理事单位。', '通过3A级企业信用等级认证。']
            }, {
              month: '11月',
              event: ['正式出海东南亚，新品牌Assetcircle成功落地。']
            }
          ]
        }, {
          year: 2018,
          content: [
            {
              month: '8月',
              event: ['完成C轮融资，融资额过亿，由海峡资本领投，SIG等老股东跟投。', '入选《2018 中国消费经融年鉴》。']
            }, {
              month: '9月',
              event: ['成功入选微软加速器·上海，成为“黄埔四期”成员。']
            }
          ]
        }, {
          year: 2017,
          content: [
            {
              month: '8月',
              event: ['完成B轮融资，投资方包括中国华融旗下的投资平台华融天泽以及源码资本、SIG海纳亚洲。']
            }, {
              month: '',
              event: ['获得4项软件著作权。']
            }
          ]
        }, {
          year: 2016,
          content: [
            {
              month: '2月',
              event: ['催迹APP正式登陆各大应用市场。']
            }, {
              month: '6月',
              event: ['平台入选北京市2016年科技计划专项课题。', '获得SIG领投、源码资本、玖创资本跟投的A+轮融资。']
            }, {
              month: '9月',
              event: ['获得北京市新技术新产品服务认定。']
            }, {
              month: '12月',
              event: ['获得国家高新技术企业认定。']
            }
          ]
        }, {
          year: 2015,
          content: [
            {
              month: '1月',
              event: ['成为上海市信息服务行业协会会员单位。']
            }, {
              month: '4月',
              event: ['获准加入中国小微与互联网行业协会。']
            }, {
              month: '9月',
              event: ['获源码资本3000万元A轮融资。']
            }, {
              month: '10月',
              event: ['加入不良资产行业联盟。']
            }, {
              month: '',
              event: ['获得6项软件著作权。']
            }
          ]
        }, {
          year: 2014,
          content: [
            {
              month: '12月',
              event: ['12月5日，企业注册登记。']
            }
          ]
        }
      ]
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    handlePre() {
      if (this.index > 0) {
        --this.index
        this.handleSlide(this.index < 6)
      }
    },
    handleNext() {
      if (this.index < this.development.length) {
        ++this.index
        this.handleSlide(this.index < 6)
      }
    },
    handleSlide(factior) {
      // 年 .swiper-wrapper init transform: translate3d(-636px, 0px, 0px);
      if (factior) {
        let translate = -636 + (3 - this.index) * 212
        document.getElementById('year').querySelector('.swiper-wrapper').style.transform = `translate3d(${translate}px, 0px, 0px)`
      }
    },
    slideChangeTransitionEnd(e) {
      const activeIndex = e.activeIndex
      let rule = activeIndex > this.index ? activeIndex < 4 : activeIndex < 3
      this.index = e.activeIndex
      this.handleSlide(rule)
    }
  },
  components: {
    Swiper,
    SwiperSlide
  }
}
